import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Tickets from '../components/tickets';
import Answers from '../components/answers';
import TicketMeta from '../components/ticket-meta';

import CloseForm from '../components/close-form/main';
import CannedReplyForm from '../components/canned-reply-form/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(
	props => (
		<Animate>
			{props.closeFormShouldShowStatus && (
				<CloseForm
					{...props}
					validate={props.closeFormValidate}
					enableReinitialize={true}
					initialValues={props.closeFormInitialValues}
				/>
			)}

			{ props.cannedReply.shouldShowForm && (
				<CannedReplyForm
					intl={props.intl}
					form="canned-reply-form"
					initialValues={props.cannedReply.formValues}
					shouldShowForm={props.cannedReply.shouldShowForm}
					formSubmit={props.upsertCannedReply}
					enableReinitialize={true}
					closeForm={props.closeCannedReplyForm} />
			) }

			<div className="container__content thread">
				<div className="container__content-body">
					<div className="support">
						<div className="position__tickets">
							<Tickets {...props} />
						</div>
						<div className="position__answers">
							<Answers {...props} />
						</div>
						<div className="position__meta">
							<TicketMeta {...props} />
						</div>
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		affiliate: selectors.getAffiliate(state),
		affiliateLevelList: selectors.getAffiliateLevelList(state),
		threadStatusesList: selectors.getThreadStatusesList(state),
		ticketsList: selectors.getTicketsList(state),
		attachmentsInfo: selectors.getAttachmentsInfo(state),
		answerFormInitialValues: selectors.getAnswerFormInitialValues(state),
		isEditMode: selectors.getEditMode(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		pendingOfferAccessRequests: selectors.getPendingOfferAccessRequests(state),
		ticketMetaFormValue: getFormValues('ticketMetaForm')(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		closeFormInitialValues: selectors.getCloseFormInitialValues(state),
		closeFormShouldShowStatus: selectors.getCloseFormShouldShowStatus(state),
		closeFormValidate: selectors.getCloseFormValidate(state),
		cannedReply: selectors.getCannedReply(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/item/main.js